const rol = {
  admin: 1,
  staff: 4,
  center: 5,
  coordinatingStaff: 6,
}

export default rol
